import { connect } from 'react-redux';
import { fetchZipJobStatus } from 'src/reducers/employees/employeePays';
import { getSelectOptions } from 'src/reducers/selectOptions';
import { getExtras } from 'src/reducers/common/listReducer';
import DownloadPayReports from '../components/DownloadPayReports';

function mapStateToProps(state) {
  return {
    uniquePaymentDates: getSelectOptions(state, 'uniquePaymentDates'),
    downloadObj: getExtras('employeePays', state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchZipJobStatus: (objId) => {
      dispatch(fetchZipJobStatus(objId));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DownloadPayReports);
